import { gql } from "@apollo/client";

import { USER_FRAGMENT } from "./fragments";

export const CREATE_USER = gql`
  ${USER_FRAGMENT}
  mutation CreateUser($input: UserCreateInput!) {
    userCreate(input: $input) {
      ...User
    }
  }
`;

export const UPDATE_USER = gql`
  ${USER_FRAGMENT}
  mutation UpdateUser($id: Int!, $input: UserUpdateInput!) {
    userUpdate(id: $id, input: $input) {
      ...User
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($id: Int!) {
    userDelete(id: $id) {
      id
    }
  }
`;
